// extracted by mini-css-extract-plugin
export default {"PopoverContentContainer":"_PopoverContentContainer--dmC_G","PopoverTrigger":"_PopoverTrigger--gWGZS"};